import styled from 'styled-components';

export const UiFooter = styled.div`
	margin-top: auto;
`;

export const UiRow = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 0;
	font-size: 0.675rem;
	font-family: ${({ theme }) => theme.typography.fontFamily};
	color: #a1a4b1;
`;

export const UiContent = styled.div`
	color: #a1a4b1;
	font-size: 0.675rem;
	padding: 0 1rem;
	text-align: right;
`;

export const UiContentWrapper = styled.div`
	color: #a1a4b1;
	font-size: 0.675rem;
	padding: 0 1rem;
	display: flex;
	justify-content: center;
`;

export const UiLink = styled.div`
	margin-left: 24px;
	font-size: 0.675rem;
	cursor: pointer;
`;
